
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AppNavigationRouterLink',

  props: {
    path: {
      type: String,
      required: true
    },
    routeName: {
      type: String,
      required: true
    },
    desktopOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  emits: ['close-navigation'],

  setup(props, context) {
    const closeNavigation = () => context.emit('close-navigation');

    return {
      props,
      closeNavigation
    };
  }
});
